"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReloadIcon = void 0;
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const ReloadIcon = (_a) => {
    var { stroke = 'currentColor' } = _a, props = __rest(_a, ["stroke"]);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), react_1.default.createElement("path", { d: "M4.83998 8C5.57767 6.72229 6.65432 5.67345 7.95091 4.96946C9.2475 4.26547 10.7135 3.93375 12.1869 4.01097C13.6602 4.08818 15.0835 4.57133 16.2994 5.40699C17.5153 6.24266 18.4765 7.39828 19.0765 8.74611M3 5.51537L3.72941 8.6749C3.85365 9.21303 4.3906 9.54856 4.92873 9.42433L8.08827 8.69492M18.6964 15.9999C17.9587 17.2776 16.8821 18.3264 15.5855 19.0304C14.2889 19.7344 12.8229 20.0661 11.3495 19.9889C9.87617 19.9117 8.45287 19.4286 7.23697 18.5929C6.02107 17.7572 5.05995 16.6016 4.45986 15.2538M20.5364 18.4845L19.807 15.325C19.6828 14.7869 19.1458 14.4513 18.6077 14.5756L15.4481 15.305", fill: "none", stroke: stroke, strokeWidth: "1.5", strokeLinecap: "round" })));
};
exports.ReloadIcon = ReloadIcon;
exports.default = exports.ReloadIcon;
